/* eslint-disable max-len */
/**
 * English translations.
 */
export default {
  ACTION: {},
  ERROR: {
    DELETE_TWITCH: 'Error canceling Twitch integration',
    ERROR: 'Error',
    FETCH_DATA: 'Fetch data'
  },
  HEADER: {
    DATE: 'Date',
    MESSAGE: 'Message',
    NAME: 'Name',
    ORDER_CODE: 'Order code',
    ORDER_VALUE: 'Amount'
  },
  LABEL: {
    ACTIVE_SINCE: 'Active since',
    INTEGRATIONS: 'Integrations',
    TWITCH: 'Twitch',
    TWITCH_AUTH: 'Twitch Permissions',
    TWITCH_AUTHORIZED_INFORMATION:
      'Prozis has permission to create Twitch alerts while streaming.',
    TWITCH_INFORMATION:
      'Prozis will request permission to create Twitch alerts while streaming.',
    TWITCH_INTEGRATION: 'Twitch Integration'
  },
  SENTENCE: {},
  SUCCESS: {
    DELETE_TWITCH: 'Twitch integration canceled',
    SUCCESS: 'Success'
  },
  TOOLTIP: {
    ORDER_CODE: 'Order code'
  }
};
